import { createSelector } from 'reselect';
import moment from 'moment-timezone';


/**
* Данные для проходов
*/
const selectPasses = createSelector(
  [
    state => state.passages.data.passages,
    (_, { params: { date2 } }) => !!date2,
    // (state, { params: { id } }) => ((state.students.data[id] && state.students.data[id].timezone) || 'Europe/Moscow'),
    // изменено (timezone), устройство всегда возвращает время GMT+3,
    () => 'Europe/Moscow',
    (state, { params: { id } }) => ((state.students.data[id] && state.students.data[id].gender)
      || 'androgynous'),
    (_, { t }) => t,
  ],
  (passages, isPeriod, timezone, gender, t) =>
    passages.map(({ id, action, created, trackable: { place, comment } }) => ({
      id,
      action,
      actionText: action === 'in'
        ? t('passage_in', { context: gender })
        : t('passage_out', { context: gender }),
      place,
      comment,
      time: moment(created).tz(timezone).format('H:mm'),
      date: isPeriod && moment(created).tz(timezone).format('DD.MM'),
    }))
);

export default selectPasses;
